import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { accessPortal } from '../../api/axios.js';
import { useUser } from '../../context/userContext.js';
import Card from '../../components/Card.js';
import BaseLayout from '../../components/BaseLayout.js';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { refreshSubscription } = useUser();

  useEffect(() => {
    refreshSubscription();
  }, [location.pathname]);

  const handleManageBilling = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await accessPortal();
      
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        throw new Error('No portal URL returned');
      }
    } catch (error) {
      console.error('Error accessing billing portal:', error);
      setError('Could not access billing portal. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseLayout>
    <div className="subscription-success-container">
      <Card>
        <div className="success-content">
          <div className="success-icon">✓</div>
          <h2>Payment Successful</h2>
          <p>You now have access to premium features.</p>
          
          <div className="divider"></div>
          
          <div className="button-container">
            <button
              onClick={() => navigate('/settings')}
              className="secondary-button"
            >
              Return to Settings
            </button>
            
            <button
              onClick={handleManageBilling}
              disabled={loading}
              className="primary-button"
            >
              {loading ? 'Loading...' : 'Manage Billing'}
            </button>
          </div>
          
          {error && <p className="error-message">{error}</p>}
        </div>
      </Card>
      
      <style jsx>{`
        .subscription-success-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          padding: 20px;
        }
        
        .success-content {
          text-align: center;
        }
        
        .success-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 64px;
          margin: 0 auto 24px;
          background-color: #6B3A8F;
          color: white;
          border-radius: 50%;
          font-size: 32px;
        }
        
        h2 {
          margin-bottom: 16px;
          color: #E1E1E6;
          font-family: 'Poppins', sans-serif;
        }
        
        p {
          margin-bottom: 24px;
          color: #999;
          font-family: 'Poppins', sans-serif;
        }
        
        .divider {
          height: 1px;
          background-color: #444;
          margin: 24px 0;
        }
        
        .button-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        
        button {
          width: 100%;
          padding: 12px 0;
          border-radius: 4px;
          font-family: 'Poppins', sans-serif;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .secondary-button {
          background-color: transparent;
          border: 1px solid #6B3A8F;
          color: #6B3A8F;
        }
        
        .secondary-button:hover {
          background-color: rgba(107, 58, 143, 0.1);
        }
        
        .primary-button {
          background-color: #6B3A8F;
          border: none;
          color: white;
        }
        
        .primary-button:hover {
          background-color: #7d4ba6;
        }
        
        .primary-button:disabled {
          background-color: #543069;
          cursor: not-allowed;
        }
        
        .error-message {
          margin-top: 16px;
          color: #ff6b6b;
        }
        
        @media (min-width: 768px) {
          .button-container {
            flex-direction: row;
            justify-content: center;
          }
          
          button {
            width: auto;
            padding: 12px 24px;
          }
        }
      `}</style>
    </div>
    </BaseLayout>
  );
};

export default SubscriptionSuccess;